export default "__VITE_ASSET__Cq0rLN$F__"